import queryString from 'query-string';

import {
  PUBLIC_UNIT_BASE,
  PUBLIC_TOPIC_BASE,
  PUBLIC_HOME,
} from 'global/public-routes.constants';
import { PRIVATE_MY_ASSIGNMENTS } from 'global/private-routes.constants';
import { isUserClassHomeUrl } from 'approot/shared/logic/is-user-class-home-url';
import { setGlobalModal, GlobalModalOptions } from './global-modals.apollo';
import { isKeepOpenOnLoadModal } from 'approot/shared/modal/modal.utils';
import { ModalKey } from 'approot/shared/modal/modal.constants';
import { setSigninRedirectionPathForSession } from 'lib/session/session-storage';

const PAGE_WHITELIST = [
  `${PUBLIC_TOPIC_BASE}/`,
  `${PUBLIC_UNIT_BASE}/`,
  PRIVATE_MY_ASSIGNMENTS,
];

export function isLessonPath(path: string) {
  return /^.*\/?lesson\/[^/]+\/?$/.test(path);
}

export function isAssessmentPath(path: string) {
  return /^.*\/?assessment\/[^/]+\/?$/.test(path);
}

export function isOnWhitelistedPage(pathname: string) {
  return (
    pathname === PUBLIC_HOME ||
    isUserClassHomeUrl(pathname) ||
    PAGE_WHITELIST.some(page => pathname.includes(page)) ||
    isLessonPath(pathname) ||
    isAssessmentPath(pathname)
  );
}

export function openAccessDeniedModal() {
  setGlobalModal(ModalKey.DENIED);
}

export function openAdminModal() {
  setGlobalModal(ModalKey.ADMIN);
}

export function openInactiveAccountModal(options?: GlobalModalOptions) {
  setGlobalModal(ModalKey.INACTIVE_ACCOUNT, options);
}

export function openJoinModal() {
  setGlobalModal(ModalKey.JOIN);
}

export function openSignInModal() {
  setSigninRedirectionPathForSession();
  setGlobalModal(ModalKey.SIGNIN);
}

export function openCreateOrChooseClassModal() {
  setGlobalModal(ModalKey.CREATE_OR_CHOOSE_CLASS);
}

export function openCreateClassModal() {
  setGlobalModal(ModalKey.CREATE_CLASS);
}

export const openChooseUserJoinModal = (options?: GlobalModalOptions) => {
  setGlobalModal(ModalKey.CHOOSE_USER_JOIN, options);
};

export const openChooseUserSignInModal = (options?: GlobalModalOptions) => {
  setSigninRedirectionPathForSession();
  setGlobalModal(ModalKey.CHOOSE_USER_SIGNIN, options);
};

export const openSigninClassSelectionModal = () => {
  setGlobalModal(ModalKey.SIGNIN_CLASS_SELECTION);
};

export const loadModalFromQuery = () => {
  const query = queryString.parse(window.location.search);
  const modalKey = query.modal;

  if (modalKey && isKeepOpenOnLoadModal(modalKey)) {
    setGlobalModal(modalKey);
  }
};
